export enum JobStatusEnum {
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded'
}
